import { useEffect } from "react";

/** Light-only theme — kept as a stub for backward compat. */
export const useTheme = () => {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    document.documentElement.style.colorScheme = "light";
  }, []);
  return { theme: "light", toggle: () => {}, setTheme: () => {} };
};
